import { NOOP } from '@vue/shared'
import { buildProps, definePropType, mutable } from '@element-plus/utils'
import { uploadBaseProps } from './upload'

import { uploadCropperProps } from './upload-cropper'
import type { ExtractPropTypes } from 'vue'
import type {
  UploadFile,
  UploadHooks,
  UploadProgressEvent,
  UploadRawFile,
  UploadUserFile,
} from './upload'
import type UploadContent from './upload-content.vue'
import type { UploadAjaxError } from './ajax'

export const uploadContentProps = buildProps({
  ...uploadBaseProps,
  ...uploadCropperProps,
  // override
  fileList: {
    type: definePropType<UploadUserFile[]>(Array),
    default: () => mutable([] as const),
  },

  beforeUpload: {
    type: definePropType<UploadHooks['beforeUpload']>(Function),
  },
  onRemove: {
    type: definePropType<
      (file: UploadFile | UploadRawFile, rawFile?: UploadRawFile) => void
    >(Function),
    default: NOOP,
  },
  onStart: {
    type: definePropType<
      (rawFile: UploadRawFile, updateIndex?: number) => void
    >(Function),
    default: NOOP,
  },
  onSuccess: {
    type: definePropType<
      (
        response: any,
        rawFile: UploadRawFile,
        boolListIgnore?: boolean,
        updateIndex?: number
      ) => unknown
    >(Function),
    default: NOOP,
  },
  onProgress: {
    type: definePropType<
      (evt: UploadProgressEvent, rawFile: UploadRawFile) => void
    >(Function),
    default: NOOP,
  },
  onError: {
    type: definePropType<
      (err: UploadAjaxError, rawFile: UploadRawFile) => void
    >(Function),
    default: NOOP,
  },
  onExceed: {
    type: definePropType<UploadHooks['onExceed']>(Function),
    default: NOOP,
  },
  revokeObjectURL: {
    type: Function,
    default: NOOP,
  },
} as const)

export type UploadContentProps = ExtractPropTypes<typeof uploadContentProps>

export type UploadContentInstance = InstanceType<typeof UploadContent>

export type BeforeUploadType = Exclude<
  ReturnType<UploadHooks['beforeUpload']>,
  Promise<any>
>
